import { render, staticRenderFns } from "./tooltip-component.vue?vue&type=template&id=80034c42&scoped=true"
import script from "./tooltip-component.vue?vue&type=script&lang=js"
export * from "./tooltip-component.vue?vue&type=script&lang=js"
import style0 from "./tooltip-component.vue?vue&type=style&index=0&id=80034c42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80034c42",
  null
  
)

export default component.exports